<template>
  <div :id="id" style="width:100%;height: 460px;"></div>
</template>
<script>
import { Treemap } from '@antv/g2plot';

export default {
  props: {
    list: Array
  },
  data() {
    return {
      dom: {},
      id: 'container_v' + Math.random(),
      TreemapPlot: {}
    };
  },
  watch: {
    list() {
      this.TreemapPlot.update(this.getOptions());
    }
  },
  created() {},
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      this.TreemapPlot = new Treemap(this.id, this.getOptions());
      this.TreemapPlot.render();
    },
    getOptions() {
      const data = this.list;
      return {
        data: {
          name: 'root',
          children: data
        },
        colorField: 'label'
      };
    }
  }
};
</script>
<style lang="less" scoped></style>
